export default "__VITE_ASSET__S2R_$hB6__"